// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31jO8","left":"styles_left__13ATZ"};